/* global $ */
import { occurrences } from "$json/lib/text-utils.js";
import { getWidget } from "./form-widgets.js";
import {
  always,
  assoc,
  compose,
  cond,
  curry,
  either,
  path,
  propEq,
  T,
  tap
} from "./functional.js";
import { _ } from "./gettext.js";
import { quotable } from "./quotable.js";
import { format, formatPlus } from "./text-utils.js";
import { listtypes, choosemultiple } from "./types.js";

const numofnewlines = curry(occurrences)("\n");

// Validate actual input, return true if it's ok, throw an error otherwise.
export function validateInput(node) {
  const $node = $(node),
    control = $node.data("control");
  let ok = true,
    re,
    errortext,
    val,
    category,
    multiple;

  if (control === undefined) {
    throw "Not a BB widget";
  }

  if (control.visible === false) {
    return true;
  }
  category = listtypes[control.controltype];
  multiple = choosemultiple[control.controltype];

  val = $node.val();

  if (control.stringmask) {
    try {
      // eslint-disable-next-line security/detect-non-literal-regexp -- We have to trust this. A regexp from the model
      re = new RegExp(control.stringmask);
    } catch {
      console.warn(
        format(
          "Control {id} has illegal stringmask property: {stringmask} -- ignoring",
          control
        )
      );
    }
    if (re && !re.test(val))
      throw format(
        control.errortext,
        compose(assoc("value", val), quotable)(control)
      );
  }
  if (control.notnull) {
    if (category === "LIST") {
      ok = $node.is(":has(:checked)");
    } else if (category === "BOX") {
      // There could be a faux, checked, option telling us to
      // fill in the field. That is the second check here.
      ok = val !== null && val !== "";
    } else if (control.controltype == "checkbox") {
      ok = $node.is(":checked");
    } else if (control.controltype === "grid") {
      if (control.addallowed === false) {
        const checkable = control.columns.find(
          either(
            propEq("controltype", "radiobutton"),
            propEq("controltype", "checkbox")
          )
        );
        if (checkable) {
          ok = $node.is(":has(:checked)");
        }
      } else {
        // A required grid should have at least one row.
        // But if no rows **can** be added it would be rude and confusing to complain to the end-user.
        ok = control.value.length > 0 || control.addallowed === false;
      }
    } else {
      re = /\S/;
      ok = re.test(val);
    }
    if (!ok) {
      throw cond([
        [path(["metadata", "errrequired"]), path(["metadata", "errrequired"])],
        [
          propEq("controltype", "datetimepicker"),
          compose(c => formatPlus(_("Date required"), c), quotable)
        ],
        [
          always(["BOX", "LIST"].indexOf(category) > -1),
          compose(
            c =>
              format(
                multiple
                  ? _("MULTIPLE required", _("Choice required"))
                  : _("SINGLE required", _("Choice required")),
                c
              ),
            quotable
          )
        ],
        [T, compose(c => format(_("Field required"), c), quotable)]
      ])(control);
    }
  }
  if (control.maxlength && control.maxlength > 0) {
    ok = val.length + numofnewlines(val) <= control.maxlength;
    if (!ok) {
      throw format(
        path(["metadata", "errtexttoolong"])(control) ||
          _("Text length exceeds the maximum of {maxlength} characters"),
        quotable(control)
      );
    }
  }
  if (getWidget(control.controltype).validate) {
    return getWidget(control.controltype).validate(control, val);
  }
  return true;
}
